export default "__VITE_ASSET__bMny8Hpl__";